// "use strict";
import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import c from "@/constants";

let config = {
  baseURL: c.API_BASE_URL
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded"
  // }
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // Update token axios header
    let token = store.state.auth.token;
    if (token) {
      config.headers.common["Authorization"] = token;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    // let message = "Oppss, ada kesalahan di Server!";
    let message = "";
    if (navigator.onLine && typeof error.response !== "undefined") {
      if (error.response.status == 401 && store.state.ui.layout == "Private") {
        // token expired
        store.dispatch("auth/LOGOUT");
        message = "Sesi sudah habis, login kembali!";
        // redirect
        router.push({
          path: "/",
          query: { redirect: router.history.current.fullPath }
        });
      } else if (typeof error.response.data !== "undefined") {
        if (typeof error.response.data.message !== "undefined")
          message = error.response.data.message;
      }
      if (process.env.NODE_ENV !== "production") console.log(error.response);
    }
    if (message) store.commit("ERROR", message);
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
